export var createTrustedTypesPolicy = function (policyName) {
    var _a;
    var ttWindow = window;
    var trustedTypePolicy;
    if ((_a = ttWindow === null || ttWindow === void 0 ? void 0 : ttWindow.trustedTypes) === null || _a === void 0 ? void 0 : _a.createPolicy) {
        try {
            trustedTypePolicy = ttWindow.trustedTypes.createPolicy(policyName, {
                createScriptURL: function (url) {
                    var parseUrl;
                    try {
                        parseUrl = new URL(url);
                    }
                    catch (error) {
                        throw new Error("Invalid script url " + url);
                    }
                    if ((parseUrl === null || parseUrl === void 0 ? void 0 : parseUrl.protocol) !== 'https:') {
                        throw new Error("Only https protocol is allowed for script url " + url);
                    }
                    return url;
                },
                createScript: undefined,
                createHTML: undefined,
            });
        }
        catch (error) {
            console.error('Failed to create trusted type policy', error);
        }
    }
    return trustedTypePolicy;
};
